import {
  FETCH_UPCOMING_SESSIONS_REQUEST,
  FETCH_UPCOMING_SESSIONS_SUCCESS,
  FETCH_UPCOMING_SESSIONS_FAILURE,
  RESET_UPCOMING_SESSIONS
} from "../actions/upcomingSessionTypes";

const initialState = {
  sessionloading: false,
  upcomingSessions: [],
  error: null,
};

const upcomingSessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_UPCOMING_SESSIONS_REQUEST:
      return { ...state, sessionloading: true };

    case FETCH_UPCOMING_SESSIONS_SUCCESS:
      return { ...state, sessionloading: false, upcomingSessions: action.payload };

    case FETCH_UPCOMING_SESSIONS_FAILURE:
      return { ...state, sessionloading: false, error: action.payload };

      case RESET_UPCOMING_SESSIONS:
        return initialState;

    default:
      return state;
  }
};

export default upcomingSessionReducer;
